import Facebook from '~/components/CustomIcons/Facebook';
import Twitter from '~/components/CustomIcons/Twitter';
import YouTube from '~/components/CustomIcons/YouTube';
import TwitterX from '~/components/CustomIcons/X';
import LinkedIn from '~/components/CustomIcons/LinkedIn';
import Twitch from '~/components/CustomIcons/Twitch';
import Hopin from '~/components/CustomIcons/Hopin';
import CustomRTMP from '~/components/CustomIcons/RtmpServer';
import OnAir from '~/components/CustomIcons/OnAirBasic';
import WhatsApp from '~/components/CustomIcons/WhatsApp';

export {
	Facebook,
	Twitter,
	WhatsApp,
	YouTube,
	TwitterX,
	LinkedIn,
	Twitch,
	Hopin,
	CustomRTMP,
	OnAir,
};
